import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store/index'
import javascriptBridge from '@/utils/javascriptBridge'

const routes = [
  {
    path: '/splash',
    name: 'splash',
    component: () => import('../views/SplashView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { requiresAuth: false },
  },
  // sns로그인 최초1회 id, pw 입력받는 폼
  {
    path: '/login/init',
    name: 'init-pwd',
    component: () => import('../views/InitPasswordView.vue'),
    meta: { requiresAuth: false },
  },
  // 마이페이지
  {
    path: '/mypage',
    name: 'mypage',
    component: () => import('../views/MypageView.vue'),
    meta: { requiresAuth: true },
  },
  // 공지사항
  {
    path: '/notice',
    name: 'notice',
    component: () => import('../views/NoticeView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/notice/detail',
    name: 'noticeDetail',
    component: () => import('../views/notice/DetailView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/notice/detail2/:id',
    name: 'noticeDetail2',
    component: () => import('../views/notice/DetailView2.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/popup/detail',
    name: 'popupDetail',
    component: () => import('../views/popup/DetailView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('../views/CalendarView.vue'),
    meta: { requiresAuth: false },
  },
  // 알림함
  {
    path: '/alarm',
    name: 'alarm',
    component: () => import('../views/alarm/AlarmView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/alarm/reserve',
    name: 'alarmReserve',
    component: () => import('../views/alarm/AlarmReserveView.vue'),
    meta: { requiresAuth: true },
  },
  // 전자출결
  {
    path: '/atdc',
    name: 'atdc',
    component: () => import('../views/atdc/AtdcView.vue'),
    meta: { requiresAuth: true },
  },
  // 상담 신청
  {
    path: '/counsel',
    name: 'counsel',
    component: () => import('../views/counsel/CounselView.vue'),
    meta: { requiresAuth: true },
  },
  // 404 notFound 및 에러
  {
    path: '/:catchAll(.*)', // 잘못된 경로를 모두 잡아줍니다.
    name: 'error',
    component: () => import('../views/ErrorView.vue'),
    meta: { requiresAuth: false },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.name === 'home') {
      // 홈 화면으로 이동할 때는 항상 맨 위로 스크롤 (안드로이드 뒤로가기 시 바텀시트 2번 올라오는 현상 있음)
      return { top: 0 }
    } else if (savedPosition) {
      // 뒤로 가기 시 이전 위치로
      return savedPosition
    } else {
      // 새로운 페이지로 이동 시 맨 위로
      return { top: 0 }
    }
  },
})

// 라우터 이동 시
router.beforeEach((to, from, next) => {
  // javascriptBridge.notchDisable()

  // store.commit('START_SPINNER') // 로딩 시작
  if (to.meta.requiresAuth) {
    // 로그인토큰이 있어야 하는 메뉴
    if (!store.getters.getUserToken) {
      // 로그인토큰이 없으면 로그인 화면으로 이동
      alert('로그인 후 이용해주세요.')
      next('/login')
    } else {
      // 로그인토큰이 있으면 정상
      next()
    }
  } else {
    next()
  }
})

// 라우터 이동 후
router.afterEach((to) => {
  // store.commit('END_SPINNER') // 로딩 종료
})

export default router
